/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivateCenterDto } from '../../models/activate-center-dto';
import { CenterDto } from '../../models/center-dto';

export interface AdminCenterControllerActive$Params {
  id: string;
      body: ActivateCenterDto
}

export function adminCenterControllerActive(http: HttpClient, rootUrl: string, params: AdminCenterControllerActive$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
  const rb = new RequestBuilder(rootUrl, adminCenterControllerActive.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterDto>;
    })
  );
}

adminCenterControllerActive.PATH = '/api/center/admin/{id}/active';
